import { render, staticRenderFns } from "./AiProcessorSettingsCard.vue?vue&type=template&id=031176c8&scoped=true&"
import script from "./AiProcessorSettingsCard.vue?vue&type=script&lang=js&"
export * from "./AiProcessorSettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./AiProcessorSettingsCard.vue?vue&type=style&index=0&id=031176c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031176c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VExpandTransition,VSelect,VSwitch,VTextarea})
